import { render, staticRenderFns } from "./BillapReportDetail.vue?vue&type=template&id=258457eb"
import script from "./BillapReportDetail.vue?vue&type=script&lang=js"
export * from "./BillapReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports